import { ViewColumnsIcon } from '@heroicons/react/20/solid';

const NewArrivals = () => {
    const subCategories = [
        { name: 'Totes', href: '#' },
        { name: 'Backpacks', href: '#' },
        { name: 'Travel Bags', href: '#' },
        { name: 'Hip Bags', href: '#' },
        { name: 'Laptop Sleeves', href: '#' },
    ];

    return (

        <div className="bg-gray-100 sm:p-5">
            <div className="bg-white rounded-lg shadow-lg p-8 px-4 max-w-5xl mx-auto">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 space-y-4 md:space-y-0">
                    <h1 className="sm:text-3xl text-2xl font-bold text-gray-700">New Arrivals</h1>
                    <div className="flex items-center space-x-4 text-gray-500">
                        <span>Sort</span>
                        <ViewColumnsIcon className="h-6 w-6" />
                    </div>
                </div>

                <div className="lg:flex">
                    {/* Sidebar */}
                    <div className="lg:w-1/4 w-full mb-8 lg:mb-0 space-y-6">
                        {/* Categories List */}
                        <ul className="space-y-4">
                            {subCategories.map((category) => (
                                <li key={category.name} className="text-lg border-b pb-3 text-gray-700 hover:text-gray-900 cursor-pointer">
                                    {category.name}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Main Content */}
                    <div className="lg:w-3/4 w-full lg:ml-8">
                        <div className="relative h-96 lg:h-full overflow-hidden rounded-xl border border-dashed border-gray-400 bg-gray-50">
                            <svg className="absolute inset-0 h-full w-full stroke-gray-300" fill="none">
                                <defs>
                                    <pattern
                                        id="pattern-4d2f8758-2f66-4332-9b69-ca19e9dfc001"
                                        x="0"
                                        y="0"
                                        width="10"
                                        height="10"
                                        patternUnits="userSpaceOnUse"
                                    >
                                        <path d="M-3 13L15-5M-5 5l18-18M-1 21L17 3"></path>
                                    </pattern>
                                </defs>
                                <rect
                                    stroke="none"
                                    fill="url(#pattern-4d2f8758-2f66-4332-9b69-ca19e9dfc001)"
                                    width="100%"
                                    height="100%"
                                ></rect>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}


export default NewArrivals;